<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <orden-compra-list ref="list" @show="show" @edit="edit" />
    </template>

    <orden-compra-desde-productos-create
      v-if="creating"
      :open="creating"
      :items="[]"
      :orden-compra-id="editingOrdenCompraId"
      @created="onItemCreated"
      @close="onCreateClose"
    />

    <orden-compra-show
      v-if="showing"
      :open="showing"
      :orden-compra-id="selectedId"
      @close="showing = false"
      @refreshed="refetchList"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import { CrudLayout, Snackbar } from "@dracul/common-frontend";
import OrdenCompraList from "../OrdenCompraList.vue";
import OrdenCompraDesdeProductosCreate from "../../../../producto/pages/ProductoManagementPage/OrdenCompraDesdeProductosCreate/OrdenCompraDesdeProductosCreate.vue";
import OrdenCompraShow from "../OrdenCompraShow.vue";

export default {
  name: "OrdenCompraCrud",
  components: {
    CrudLayout,
    Snackbar,
    OrdenCompraList,
    OrdenCompraDesdeProductosCreate,
    OrdenCompraShow,
  },
  data() {
    return {
      title: "Órdenes de compra",
      subtitle: "Pedidos a proveedores, recepción de mercadería y pagos",
      flash: null,
      creating: false,
      showing: false,
      selectedId: null,
      editingOrdenCompraId: null,
    };
  },
  methods: {
    create() {
      this.editingOrdenCompraId = null;
      this.creating = true;
    },
    edit(item) {
      this.editingOrdenCompraId = item.id || item._id;
      this.creating = true;
    },
    show(item) {
      this.selectedId = item.id || item._id;
      this.showing = true;
    },
    onCreateClose() {
      this.creating = false;
      this.editingOrdenCompraId = null;
    },
    onItemCreated(wasUpdate) {
      this.flash = wasUpdate ? "Orden de compra actualizada" : "Orden de compra creada";
      this.creating = false;
      this.editingOrdenCompraId = null;
      this.refetchList();
    },
    refetchList() {
      this.$refs.list && this.$refs.list.fetch();
    },
  },
};
</script>
